import { Component, OnInit } from "@angular/core";

import { MembersService } from "src/app/core/members.service";
import { NotificationService } from "src/app/core/notification.service";
import { StrikeService } from "src/app/core/strike.service";
import { MemberDetails } from "src/app/shared/interfaces/member-details";
import { StrikePicketLines } from "src/app/shared/interfaces/strike-picketlines";
import { StrikeShifts } from "src/app/shared/interfaces/strike-shifts";

import { ModalService } from "../../../core/modal.service";

@Component({
  selector: "app-edit-member",
  templateUrl: "./edit-member.component.html",
  styleUrls: ["./edit-member.component.css"],
})
export class EditMemberComponent implements OnInit {
  memberId = "";
  paramId = "";
  member: MemberDetails = { MemberId: "" };
  picketLines: StrikePicketLines = [];
  shifts: StrikeShifts = [];
  newDebitCardSwipeInfo = "";  // KLD: assuming string since it comes from form input
  disableButton = false;

  constructor(
    private members: MembersService,
    private strikes: StrikeService,
    private modal: ModalService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.loadMemberInfo();
    this.loadPicketlines();
    this.loadShifts();
  }

  async loadMemberInfo() {
    if (this.memberId) {
      this.member = await this.members.getMemberInfo(this.memberId);
    }
  }

  async loadPicketlines() {
    if (this.paramId) {
      const picketlines = await this.strikes.getStrikePicketlines(this.paramId);
      this.picketLines = picketlines;
    }
  }

  async loadShifts() {
    if (this.paramId) {
      const shifts = await this.strikes.getStrikeShifts(this.paramId);
      this.shifts = shifts;
    }
  }

  async updateMember() {
    this.notificationService.displayInfo(
      "Updating " + this.member.MemberName + " information",
    );
    this.disableButton = true;
    // TODO REVIEW: where is newDebitCardSwipeInfo set??
    this.member.DebitCard = this.newDebitCardSwipeInfo;

    const response = await this.members.updateMemberInfo(this.member);

    if (response.success) {
      this.notificationService.displaySuccess(
        this.member.MemberName + " information has been updated",
      );
    } else {
      this.notificationService.displayError("Error updating member info");
    }

    this.modal.submitClicked.next(true);

    this.disableButton = false;
    this.modal.closeModal();
  }

  cancelAction() {
    this.modal.closeModal();
  }
}
